import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';

import { RootStoreContext } from '../../../../../context';

import './Header.css';
import '../../../../../css/utils/flex.css';


@observer
class Header extends Component {
  static contextType = RootStoreContext;

  render() {
    const { currentAnchors } = this.props;
    const {
      privateMessagingStore: {
        activeConversationHeader,
        isBanned,
        memberAnchors,
      },
      tippingStore,
      loggedInUser: {
        account: {
          id: userId,
          anchor,
          anchorSubscriptions,
        },
      },
    } = this.context;

    const isAnchor = anchor;
    let isSubscribed = true;
    let showTipButton = false;
    const nakedNewsLiveId = 241;
    let member = null;

    if (activeConversationHeader) {
      isSubscribed = !!anchorSubscriptions.find((sub) => sub.anchorUsername === activeConversationHeader.username || sub.anchorNickname === activeConversationHeader.username);

      member = memberAnchors.find((anchor) =>
        anchor.username === activeConversationHeader.username ||
          anchor.nickname === activeConversationHeader.username
      );

      if (member) {
        currentAnchors.forEach((anchor) => {
          if (anchor.id === member.id || member.id === nakedNewsLiveId) {
            showTipButton = true;
          }
        });
      }
    }

    const handleTip = () => {
      tippingStore.setTippingModal({
        name: '',
        username: member.username || activeConversationHeader.username,
        id: '',
      });
    };

    const activeConversationImageStyle = {};
    const hasImage = activeConversationHeader?.anchorImage;
    if (hasImage) {
      activeConversationImageStyle.background = `url(${activeConversationHeader.anchorImage}) no-repeat center center / cover`;
    }

    return (
      <header id="active-conversation-header">
        {activeConversationHeader && (
          <Fragment>
            <div className="flex items-center">
              <div
                className="avatar flex justify-center items-center"
                style={activeConversationImageStyle}
              >
                {!hasImage && activeConversationHeader.initials}
              </div>
              <div>
                <h4 className="username">{activeConversationHeader.username}</h4>
                <p className="activity-label">
                  {activeConversationHeader.online && <span className="indicator" />}
                  <span>{activeConversationHeader.online ? 'Active now' : 'Inactive'}</span>
                </p>
              </div>
            </div>
            {!isAnchor && !isBanned && isSubscribed && showTipButton && (
              <button
                className="btn btn-red tipping-btn"
                onClick={handleTip}
              >
                TIP $
              </button>
            )}
          </Fragment>
        )}
      </header>
    );
  }
}

export default Header;
